import { Component, OnDestroy, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-participantes-egresados-2026',
  templateUrl: './participantes-egresados-2026.component.html',
  styleUrls: ['./participantes-egresados-2026.component.scss']
})
export class ParticipantesEgresados2026Component implements OnInit, OnDestroy {
  dataNuevos: any[] = [];
  filteredData: any[] = [];
  searchText: string = '';
  p: number = 1;

  constructor() {
    this.loadExcel();
  }

  ngOnInit(): void {
    // La seccion "Nuestra comunidad" (#parthers) vive en el footer
    // compartido, asi que no se puede quitar desde el HTML de esta vista.
    // Se oculta al entrar y se restaura al salir, para no afectar
    // al resto de las rutas.
    $('#parthers').hide();
  }

  ngOnDestroy(): void {
    $('#parthers').show();
  }

  loadExcel() {
    // Nota: el codigo apuntaba a 'assets/pdf/participantes.xlsx', que ya
    // no existe en el repo (se borro; quedo el rastro en el commit
    // 125ed1d). El unico archivo presente es participantesso1.xlsx.
    const url = 'assets/pdf/participantesEgresados.xlsx';
    fetch(url)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        const workbook = XLSX.read(buffer, { type: 'array' });

        // El libro trae una sola hoja, llamada 'participantes'
        const hoja = workbook.Sheets['participantes'];

        // raw: false conserva los ceros a la izquierda de los folios
        // ("000002" se queda como texto y no se vuelve el numero 2)
        this.dataNuevos = XLSX.utils.sheet_to_json(hoja, { raw: false });

        this.filteredData = this.dataNuevos;
      })
      .catch(error => console.error('Error loading Excel file:', error));
  }

  filterData() {
    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      this.filteredData = this.dataNuevos;
      this.p = 1;
      return;
    }

    this.filteredData = this.dataNuevos.filter(participante => {
      // Las llaves se buscan por nombre normalizado, por si el Excel
      // trae mayusculas o espacios de mas en los encabezados.
      const folioKey = Object.keys(participante).find(k => k.toLowerCase().trim() === 'folio');
      const folio = folioKey && participante[folioKey] ? participante[folioKey].toString().toLowerCase() : '';
      // Tambien se busca sin ceros a la izquierda: quien teclea "2"
      // espera encontrar el folio "000002".
      const folioSinCeros = folio.replace(/^0+/, '');

      const nombreKey = Object.keys(participante).find(k => k.toLowerCase().trim() === 'nombre');
      const nombre = nombreKey && participante[nombreKey] ? participante[nombreKey].toString().toLowerCase() : '';

      return (
        folio.includes(term) ||
        folioSinCeros.includes(term) ||
        nombre.includes(term)
      );
    });

    this.p = 1; // Al filtrar se vuelve a la primera pagina
  }
getFirstName(fullName: string): string {
  if (!fullName) return '';

  const cleanName = fullName.trim();

  // Excepción para texto de folios no asignados
  if (/^folio no asignado$/i.test(cleanName)) {
    return cleanName;
  }

  const words = cleanName.split(/\s+/);

  if (words.length <= 2) return words[0];

  // Partículas y preposiciones comunes en apellidos en español
  const prefixes = new Set([
    'de', 'del', 'la', 'las', 'los', 'san', 'santa', 'santo', 'y', 'e', 'da', 'di'
  ]);

  // Agrupamos de derecha a izquierda para consolidar apellidos compuestos
  const tokens: string[] = [];
  let buffer: string[] = [];

  for (let i = words.length - 1; i >= 0; i--) {
    const current = words[i];
    const isPrefix = prefixes.has(current.toLowerCase());

    buffer.unshift(current);

    if (!isPrefix || i === 0) {
      tokens.unshift(buffer.join(' '));
      buffer = [];
    }
  }

  if (tokens.length <= 2) {
    return tokens[0];
  }

  return tokens.slice(0, -2).join(' ');
}

  // Abrevia el nombre a puras iniciales en mayuscula: "juan perez lopez"
  // queda como "J. P. L.". Es la misma funcion que trae
  // participantessorteopt; se usa cuando SEGOB pide publicar el nombre
  // propio con las iniciales de los apellidos en lugar del nombre
  // completo. Hoy la tabla muestra el nombre completo (en mayusculas por
  // CSS), asi que queda lista pero sin enganchar en el HTML.
  getInitials(fullName: any) {
    if (!fullName) {
      return '';
    }
    const nameString = fullName.toString().trim();
    const initials = nameString
      .split(/\s+/)
      .map((word: string) => word.charAt(0).toUpperCase())
      .join('. ');
    return initials + '.';
  }
}
